import React from 'react';
import { motion } from 'framer-motion';

const DownArrow = () => (
  <div className="process-flow__arrow">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M10 4L10 16M10 16L5 11M10 16L15 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>
);

const ProcessFlowTemplate = ({ params }) => {
  const steps = params?.steps || [];

  if (steps.length === 0) {
    return <p style={{ color: 'var(--panel-text-secondary)' }}>No process data available.</p>;
  }

  return (
    <div className="process-flow">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <motion.div
            className="process-flow__step"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.3, ease: [0.32, 0.72, 0, 1] }}
          >
            <div className="process-flow__step-content">
              <span className="process-flow__step-number">{index + 1}</span>
              <div className="process-flow__step-text">
                <div className="process-flow__step-label">{step.label}</div>
                <div className="process-flow__step-detail">{step.detail}</div>
              </div>
            </div>
          </motion.div>
          {index < steps.length - 1 && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: index * 0.1 + 0.05, duration: 0.2 }}
            >
              <DownArrow />
            </motion.div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProcessFlowTemplate;
